import React, { useReducer } from 'react';
import AuthContext from './authContext';
import AuthReducer from './authReducer'
import axiosClient from '../../config/axiosClient'
import tokenAuth from '../../config/tokenAuth'

import {
    REGISTRO_EXITOSO,
    REGISTRO_ERROR,
    OBTENER_USUARIO,
    LOGIN_EXITOSO,
    LOGIN_ERROR,
    CERRAR_SESION,
    RECUPERAR_USUARIO,
    EDITAR_USUARIO,
    REINICIAR_PASSWORD
} from "../../types";

const AuthState = (props) => {
    const initialState = {
        token: localStorage.getItem('token'),
        authenticated: null,
        user: null,
        msg: null,
        cargando: null
    }
    
    const [ state, dispatch ] = useReducer(AuthReducer, initialState);

    const registrarUsuario = async datos => {
        try {
            const respuesta = await axiosClient.post('/api/auth/', datos);

            dispatch({
                type: REGISTRO_EXITOSO,
                payload: respuesta.data
            });
            usuarioAutenticado();
        } catch (error) {
            const alerta = {
                msg: error.response.data.msg,
                categoria: 'alerta-error'
            }
            dispatch({
                type: REGISTRO_ERROR,
                payload: alerta
            })
        }
    }

    const usuarioAutenticado = async () => {
        const token = localStorage.getItem('token');
        if ( token ) {
            tokenAuth(token);
        }

        try {
            const respuesta = await axiosClient.get('/api/auth');
            dispatch({
                type: OBTENER_USUARIO,
                payload: respuesta.data.user
            });
        } catch (error) {
            dispatch({
                type: LOGIN_ERROR
            })
        }
    }

    const iniciarSesion = async datos => {
        await axiosClient.post('/api/auth', datos)
            .then(response=>{
                dispatch({
                    type: LOGIN_EXITOSO,
                    payload: response.data
                })
                // Obtener el usuario
                usuarioAutenticado();
            })
            .catch(error => { 
                //console.log(error); 
                const alerta = {
                    msg: "❌ El correo o la contraseña introducidos no son correctos",
                    categoria: 'alerta-error'
                }
                dispatch({
                    type: LOGIN_ERROR,
                    payload: alerta
                })
            })            
    }

    const cerrarSesion = () => {
        dispatch({
            type: CERRAR_SESION
        })
    }

    const recuperarUsuario = async datos => {
        try {
            const respuesta = await axiosClient.post('/api/auth/forgot', datos);

            dispatch({
                type: RECUPERAR_USUARIO,
                payload: respuesta.data
            });
        } catch (error) {
            const alerta = {
                msg: "❌ El correo ingresado no existe en la base de datos",
                categoria: 'alerta-error'
            }
            dispatch({
                type: REGISTRO_ERROR,
                payload: alerta
            })
        }
    }

    const editarUsuario = async usuario => {
        try {
            dispatch({
                type: EDITAR_USUARIO,
                payload: usuario
            });
        } catch (error) {
            const alerta = {
                msg: "❌ El correo ingresado no existe en la base de datos",
                categoria: 'alerta-error'
            }
            dispatch({
                type: REGISTRO_ERROR,
                payload: alerta
            })
        }
    }

    const reiniciarPassword = async datos => {
        try {
            const respuesta = await axiosClient.put('/api/auth/reset', datos);

            dispatch({
                type: REINICIAR_PASSWORD,
                payload: respuesta.data
            });
        } catch (error) {
            const alerta = {
                msg: "❌ El enlace para reestablecer la contraseña ha caducado, es necesario generar un nuevo enlace!",
                categoria: 'alerta-error'
            }
            dispatch({
                type: REGISTRO_ERROR,
                payload: alerta
            })
        }
    }

    return (
        <AuthContext.Provider
            value={{
                token: state.token,
                authenticated: state.authenticated,
                user: state.user,
                msg: state.msg,
                cargando: state.cargando,
                registrarUsuario,
                iniciarSesion,
                usuarioAutenticado,
                cerrarSesion,
                recuperarUsuario,
                editarUsuario,
                reiniciarPassword
            }}
        >{props.children}</AuthContext.Provider>
    );
}

export default AuthState;